import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./styles.css";
import { notifyAppReady, initLiveUpdates } from "./lib/liveUpdate";

// 무흔적: 앱을 새로 켤 때(콜드 스타트) 이전 세션의 미제출 초안을 비운다.
// 구겨서 버리지 않고 앱을 닫았어도 다음에 켰을 때 내용이 남지 않게. (세션 중 설정↔작성 이동은 유지.)
try {
  localStorage.removeItem("bwek_draft");
} catch {
  /* localStorage 미가용 — 무시 */
}

// 네이티브: 현재 번들이 정상임을 즉시 알림(롤백 방지) → 백그라운드로 OTA 업데이트 확인.
// 웹에선 둘 다 no-op. 앱 렌더는 막지 않는다.
void notifyAppReady();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

void initLiveUpdates();
